import React, { useEffect, useRef, useState } from 'react'

//Custom components
import { CustomDataTable } from '../../../Components/DataTable';
import { Chip, EmptyScreen, Loader } from '../../../Components/Others';
import { TextButton } from '../../../Components/Buttons';
import { APIService } from '../../../Service';
import { useParams } from 'react-router-dom';
import { ViewPanDetailModal } from '../../../Components/Modal';
import { Modal } from 'bootstrap';

const TABLE_DATA = [
    {
        stage: "1",
        detail: "PAN Details",
        status: "Completed",
        updated_date: "08 Jun 2024, 10:30 am",
    },
    {
        stage: "2",
        detail: "PAN Details",
        status: "Pending",
        updated_date: "08 Jun 2024, 10:30 am",
    },
]

const AccountCreation = () => {

    const scrollRef = useRef(null);
    const { id } = useParams();
    const isRendered = useRef(true);

    // const [currentPage, setCurrentPage] = useState(1);

    const [loader, setLoader] = useState(true);

    const [statusData, setStatusData] = useState({});

    const [viewDetailModal, setViewDetailModal] = useState(false);
    const [actionData, setActionData] = useState({});
    const [modalTitle, setModalTitle] = useState("");

    useEffect(() => {
        if (isRendered.current === true) {
            _getAccountCreationStatus();

            isRendered.current = false;

        }
    }, [isRendered]);

    useEffect(() => {
        if (viewDetailModal === true) {
            const modal = new Modal(document.getElementById('view-pan-proof-modal'));
            modal.show();
        }
    }, [viewDetailModal]);


    // handle table page change 
    // const _handlePageChange = (page_num) => {
    //     setCurrentPage(page_num);
    //     if (scrollRef.current) {
    //         scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    //     }
    // };


    const TABLE_COLUMN = [
        {
            name: 'Stage',
            selector: row => row.stage,
            width: "90px"
        },
        {
            name: 'Detail',
            selector: row => row.name,
            width: "300px",
            sortable: true
        },
        {
            name: 'Status',
            cell: (row) =>
                <>
                    {row.status !== null ?
                        <Chip label={row.status}
                            className={row.status === "Completed" ? "e-bg-green-crayola" : row.status === "Rejected" ? "e-bg-maximum-red" : "e-bg-marigold"} />
                        :
                        "-"
                    }
                </>,
            width: "140px"
        },
        {
            name: 'Action',
            cell: row =>
                <div>
                    {row.status !== null ?
                        <>
                            {row.status.toLowerCase() === "completed" ?
                                <TextButton name="View details"
                                    onClick={() => {
                                        setModalTitle(row.name);
                                        setViewDetailModal(true);
                                        setActionData(row.action);
                                    }} /> : "-"}
                        </>
                        :
                        "-"
                    }

                </div>,
            width: "140px"
        },
        {
            name: 'Last Updated On',
            selector: row => row.last_updated_on || "-",
            width: "220px"
        },
    ];

    // API - Account creation status
    const _getAccountCreationStatus = () => {

        let url = 'user/account-creation-status';

        let data = {
            "customer_id": id
        };

        APIService(true, url, data).then((response) => {

            if (response.status_code === 200) {
                setStatusData(response.data);
            } else {
                setStatusData({});
            }
            setLoader(false);
        });
    };

    return (
        <div>
            {loader ?
                <Loader className="min-vh-100 " />
                :
                <>
                    <div className='padding-32px-top padding-32px-lr pb-3'>
                        <h6 className='mb-3 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                            Profile details
                        </h6>

                        <div className='e-bg-magnolia border-radius-8  p-3 mb-2'>
                            <div className='row' >
                                <div className='col-4'>
                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                        KYC Completed Via
                                    </p>
                                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-20px'>
                                        {statusData.kyc_completed_via || "-"}
                                    </p>
                                </div>

                                <div className='col-8'>
                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                        Account Creation
                                    </p>
                                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-20px'>
                                        {statusData.account_creation_status || "-"}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <h6 className='mb-0 pt-4 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                            Account Creation Stages
                        </h6>
                    </div>

                    {Object.keys(statusData).length !== 0 && statusData.data.length !== 0 ?
                        <div className='e-data-table-wrapper-default-updated pt-0 pb-4'>
                            <CustomDataTable columns={TABLE_COLUMN}
                                data={statusData.data}
                                pagination={false}
                                // paginationPerPage={10}
                                // paginationDefaultPage={currentPage}
                                // paginationTotalRows={10}
                                // lastPage={1}
                                onChangePage={() => { }}
                            />
                        </div>
                        :
                        <EmptyScreen
                            image={require('../../../Assets/Image/NotFound/no-data.png')}
                            title='No data found'
                            description={``}
                        />}

                </>
            }


            {viewDetailModal === true &&
                <ViewPanDetailModal data={actionData}
                    title={modalTitle}
                    handleClose={() => {
                        setTimeout(() => {
                            setViewDetailModal(false);
                            setActionData({});
                            setModalTitle("");
                        }, 200);
                    }} />
            }
        </div>
    )
}

export default AccountCreation;
